export const ENGLISH_SYMBOL = 'en';
